export var popoverPortalTokens = {
  backgroundColor: function backgroundColor(_ref) {
    var palette = _ref.palette;
    return palette.neutralsWhite.hex100;
  },
  color: function color(_ref2) {
    var _color = _ref2.color;
    return _color.text.black.base;
  },
  padding: "16px",
  borderRadius: "4px",
  boxShadow: function boxShadow(_ref3) {
    var palette = _ref3.palette;
    return "0 1px 2px 2px ".concat(palette.neutralsBlack.rgba10);
  },
  arrowBoxShadow: "1px 1px 4px rgb(5 23 210 / 10%), -1px -1px 4px rgb(5 23 210 / 10%)"
};